import { render, staticRenderFns } from "./productPage.vue?vue&type=template&id=b1f7e8ba&scoped=true&"
import script from "./productPage.vue?vue&type=script&lang=js&"
export * from "./productPage.vue?vue&type=script&lang=js&"
import style0 from "./productPage.vue?vue&type=style&index=0&id=b1f7e8ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f7e8ba",
  null
  
)

export default component.exports